import { useState } from "react";
import { Modal, UploadedFileBanner } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import { DocUploadIcon } from "../../../svg/doc-upload-icon";
import DownloadIcon from "../../../svg/download-icon";
import { onSave } from "./actionHandlers/onSave";
import { useFileUpload } from "./hooks/useFileUpload";
import { useTemplateDownload } from "./hooks/useTemplateDownload";

interface CaseInitiationUploadModalProps {
  onClose: () => void;
}

const CaseInitiationUploadModal = (props: CaseInitiationUploadModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    uploadedFile,
    fileInputRef,
    handleFileChange,
    handleDrop,
    handleDragOver,
    handleDeleteFile,
  } = useFileUpload();
  const { downloadTemplate, isDownloading } = useTemplateDownload();

  const handleSave = async () => {
    setIsSubmitting(true);
    try {
      await onSave(uploadedFile, props.onClose);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      dialogId={ModalId.CASE_INITIATION_UPLOAD_MODAL}
      title="Case Initiation"
      onClose={props.onClose}
      onSave={handleSave}
      saveButtonText={isSubmitting ? "Submitting..." : "Save"}
      cancelText="Cancel"
      disableSave={isSubmitting || !uploadedFile}
    >
      <div className="flex flex-col gap-3">
        <div className="text-secondaryGray-2 flex flex-row justify-between rounded-sm bg-secondaryYellow-11 p-2 text-tiny">
          <div>Use this template before uploading</div>
          <div
            className="flex cursor-pointer flex-row items-center gap-1"
            onClick={downloadTemplate}
          >
            <DownloadIcon />
            <div className="text-tertiaryBlue-4">
              {isDownloading ? "Downloading..." : "Download Template"}
            </div>
          </div>
        </div>

        <div className="drag-drop-container">
          {!uploadedFile && (
            <div
              className="drop-file-input"
              onDrop={handleDrop}
              onDragOver={handleDragOver}
            >
              <DocUploadIcon />
              <div className="main-text">
                Drag and drop or <span>click here</span> to upload
              </div>
              <div className="sub-text">Supported file format CSV</div>
              <input
                ref={fileInputRef}
                type="file"
                accept=".csv,text/csv"
                onChange={handleFileChange}
                id="case-initiation-upload"
                name="case-initiation-upload"
              />
            </div>
          )}
        </div>

        {uploadedFile && (
          <div className="uploaded-file-container">
            <UploadedFileBanner
              fileName={uploadedFile.name}
              deleteUploadedFile={handleDeleteFile}
              currentProgress={100}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CaseInitiationUploadModal;
